import { Mongo } from "meteor/mongo";

export const Pickups = new Mongo.Collection("pickups");
